export enum Status {
    PorAceptar = 1,
    Aceptada = 2,
    Completada = 3,
    Cancelada = 4,
    Incidencia = 5,
    Programada = 6,
    Aprobada = 7,
    Rechazada = 8,
}